/**
 * Copyright (c) 2026 Constructor Technology AG. All rights reserved.
 *
 * Proprietary and confidential. Unauthorized copying, distribution, or use
 * is prohibited.
 *
 * SPDX-License-Identifier: LicenseRef-Constructor-Proprietary
 */

import { hmsAPI } from '@/api'

export const loginPost = data => hmsAPI.post('/login', data)
export const logout = () => hmsAPI.get('/logout')
export const getToken = () => hmsAPI.get('/me')
